import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box, Heading } from 'lucid-components-react';

import {
  Drupal_FieldParagraphFlexiStyledMultiSectionsFieldSections,
  Drupal_ParagraphFlexiSection
} from 'generated/graphql';
import { getProcessedValue } from 'utils/helpers';
import { Text } from 'theme/typography';

interface Props {
  entities: Drupal_FieldParagraphFlexiStyledMultiSectionsFieldSections[];
}

type CopyProps = {
  header: string;
  body: { processed?: string | null };
};

const Copy = ({ header, body }: CopyProps) => (
  <Box key={header} maxWidth={{ default: '100%', tablet: '300px' }}>
    <Heading variant="subheadS700">{header}</Heading>
    <Text
      as="div"
      textStyles="bodyS400"
    >
      {ReactHtmlParser(getProcessedValue(body))}
    </Text>
  </Box>
);

const SixScattered = ({ entities }: Props) => {
  return (
    <Box
      display={{ default: 'block', tablet: 'grid' }}
      gridColumnGap="20px"
      gridTemplateColumns={'repeat(12, 1fr)'}
      mb={11}
      px={{ default: 2, tablet: 6 }}
    >
      {entities.map(({ entity }, i) => {
        const {
          fieldFlexiHeader,
          fieldFlexiBody,
          fieldFlexiImage
        } = entity as Drupal_ParagraphFlexiSection;

        let value = null;

        const copy = <Copy body={fieldFlexiBody!} header={fieldFlexiHeader!} />;
        const img = <img alt={fieldFlexiHeader!} src={fieldFlexiImage!} />;

        if (i === 0) {
          value = (
            <>
              <Box
                gridColumn={{ default: '1 / -1', tablet: '1 / span 4' }}
                mb={{ default: 0, tablet: 8 }}
              >
                {img}
              </Box>
              <Box gridColumn="5 / span 3" mb={{ default: 10, tablet: 0 }}>
                {copy}
              </Box>
            </>
          );
        } else if (i === 1) {
          value = (
            <>
              <Box gridColumn="9 / span 4">{img}</Box>
              <Box
                gridColumn="9 / span 4"
                gridRow="2"
                mb={{ default: 10, tablet: 0 }}
                mt={{ default: 0, tablet: -8 }}
              >
                {copy}
              </Box>
            </>
          );
        } else if (i === 2) {
          value = (
            <>
              <Box gridColumn="5 / span 3">{img}</Box>
              <Box
                css={{ textAlign: 'right' }}
                gridColumn="1 / span 4"
                gridRow="2"
                mb={{ default: 10, tablet: 9 }}
              >
                {copy}
              </Box>
            </>
          );
        } else if (i === 3) {
          value = (
            <>
              <Box gridColumn="9 / span 4">{img}</Box>
              <Box
                css={{ textAlign: 'right' }}
                gridColumn="6 / span 3"
                gridRow="3"
                mb={{ default: 10, tablet: 0 }}
              >
                {copy}
              </Box>
            </>
          );
        } else if (i === 4) {
          value = (
            <>
              <Box
                gridColumn="1 / span 4"
                gridRow="3"
                mt={{ default: 0, tablet: 8 }}
              >
                {img}
              </Box>
              <Box gridColumn="1 / span 4" mb={{ default: 10, tablet: 0 }}>
                {copy}
              </Box>
            </>
          );
        } else if (i === 5) {
          value = (
            <>
              <Box gridColumn="6 / span 3">{img}</Box>
              <Box gridColumn="9 / span 4">{copy}</Box>
            </>
          );
        }

        return value;
      })}
    </Box>
  );
};

export default SixScattered;
